import dynamic from 'next/dynamic';

import { Results } from '@/components/views/port-insights/results';
import { tv } from '@/utils/styles';

// Map must be imported dynamically to avoid SSR issues. More info here https://github.com/visgl/deck.gl/issues/7735
const Map = dynamic(() => import('@/components/views/port-insights/map').then((module) => module.Map), { ssr: false });

const PortInsightsLayout = () => {
  const { base, results, mapWrapper } = styles();
  return (
    <div className={base()}>
      <div className={results()}>
        <Results />
      </div>

      <div className={mapWrapper()}>
        <Map />
      </div>
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'relative flex h-full flex-col bg-grey-100',
    results: 'absolute left-4 right-4 top-4 z-7 max-w-[452px] md:right-auto md:w-[452px] md:max-w-none 2xl:w-[550px]',
    mapWrapper: 'h-full w-full shrink-0 overflow-hidden',
  },
});

export { PortInsightsLayout };
